<template>
  <b-container>
    <b-card>
      <div slot="header">
        <b-card-title>
          Relaties
          <div class="card-header-actions">
            <b-input-group>
              <i class="fa fa-search m-2" />  
              <b-form-input
                v-model="zoekterm"
                placeholder="Zoeken"
                type="search"
                debounce="500"
              />
            </b-input-group>
          </div>
          <b-button
            icon="fa fa-save"
            variant="success"
            @click="addRelatie = true"
          >
            <i class="fa fa-plus" /> Nieuwe relatie toevoegen
          </b-button>
        </b-card-title>
      </div>
      <b-card-body>
        <b-card-group 
          deck 
          class="mb-3"
        >
          <b-card 
            v-for="(g) in groepen" 
            :key="g.value"
          >
            <b-card-title>{{ g.text }}</b-card-title>
            <b-button @click="$router.push({name: 'Relatie',params :{id : g.value}})">
              Bewerken
            </b-button>
          </b-card>
        </b-card-group>

        <b-modal 
          v-model="addRelatie" 
          title="Nieuwe relatie toevegen" 
          @ok="relatieToevoegen()"
        >
          <b-form-group label="Naam">
            <b-form-input 
              v-model="nieuwerelatie.naam" 
              placeholder="Bedrijfsnaam van de nieuwe relatie"
            />  
          </b-form-group>

          <b-form-group label="Adviesnummer">
            <b-input-group :prepend="selectedGroep.text.substring(0, 1)">
              <b-form-input 
                v-model="nieuwerelatie.adviesnummer" 
                placeholder="Adviesnummer"
                maxlength="6"
              />  
            </b-input-group>
          </b-form-group>
                
          <b-form-group label="Groep">
            <b-radio-group 
              v-model="groep" 
              :options="groepen" 
              buttons
            />
          </b-form-group>
        </b-modal>
            
        <b-table
          :items="relaties"
          :fields="[{
            key:'Adviesnummer', 
            label: 'Adviesnr.'
          },'Naam','Adres']"
          :filter="zoekterm"
          :filter-included-fields="['Naam','Adres','Postcode','Plaats','Adviesnummer']"
          bordered
          small
          hover
          show-empty
          empty-filtered-text="Geen resultaat"
          empty-text="Geen"
          select-mode="single"
          selectable
          @row-selected="onRowSelected"
        >
          <template 
            #cell(Naam)="data" 
            align="center"
          >
            <b>{{ data.item.Naam }}</b><i 
              v-if="parseValue(data.item.IsOnderhoudsfirma)"
              class="fa fa-wrench ml-2"
            />
            <i 
              v-if="parseValue(data.item.IsKeuringsinstantie)" 
              class="fa fa-certificate ml-2"
            /> 
          </template>
          <template
            #cell(Adres)="data"
            align="center"
          >
            {{ data.item.Adres }} {{ data.item.Postcode }} {{ data.item.Plaats }}<br>
            <b-link 
              v-if="data.item.Email" 
              :href="'mailto:' + data.item.Email" 
              class="mr-2"
            >
              <i 
                 
                class="fa fa-envelope-o"
              />
              {{ data.item.Email }}
            </b-link> 
            <b-link 
              v-if="data.item.FinEmail" 
              :href="'mailto:' + data.item.FinEmail" 
              class="mr-2"
            >
              <i 
                v-if="data.item.FinEmail" 
                class="fa fa-envelope-o"
              />
              {{ data.item.FinEmail }}
            </b-link>
          </template>
          <template
            #cell(Logo)="data"
            align="center"
          >
            <!---{{data.item.Logo}} --->
            <i 
              v-if="data.item.Logo != ''" 
              class="fa fa-file-o mr-2"
            /> 
            <i 
              v-if="data.item.HasCloudLogo" 
              class="fa fa-cloud mr-2"
            />
          </template>
         
          <template 
            #cell(Financieel)="data" 
            align="center"
          >
            <br>
          </template>
        </b-table>
      </b-card-body>
    </b-card>
    <router-view />
  </b-container>
</template>

<script>
import vSelect from "vue-select";
import { serviceMixin } from "@/mixins/serviceMixin";

export default {
  name: "Relaties",
  components: {
    vSelect
  },
  mixins: [serviceMixin],
  data() {
    return {
      relaties: [],
      zoekterm: null,
      addRelatie: false,
      nieuwerelatie: {
        naam: null
      },
      groep: 1,
      groepen: [{ text: 'TPA',value: 1},{text: 'DLA', value: 2},{text: 'CTC', value:3}]
    };
  },
  computed: {
    selectedGroep: function() {
      var vm = this;
      return this.groepen.filter(function(item) { return item.value == vm.groep } )[0];
    }
  },
  watch: {},
  mounted() {
    this.getRelaties();
  },
  methods: {
    parseValue(val) {
      if (val === null || val === undefined || val === '') return false
      if (val === '0' || val === false || val === 0) return false
      if (val === '1' || val === true || val === 1) return true
      return Boolean(val)
    },
    selectGroep(value) {
      this.groep = value;
      this.getRelaties();
    },
     getRelaties() {
      var vm = this;
      this.$http
        .get("/relaties")
        .then(function(response) {
        console.log(response.data);
          vm.relaties = response.data.relaties;
          console.log("Loaded");
        })
        .catch(function(error) {
          console.log("Error on Authentication", error);
        });
    },
    relatieToevoegen() {
      var vm = this;
      this.post("/relaties", {relatie:this.nieuwerelatie,groep: this.selectedGroep.value}).then(function(response) {
          console.log(response.relatie);
          // Optimistically add to Vuex relaties store so dropdowns reflect it instantly
          if (response && response.data && response.data.relatie) {
            vm.$store.dispatch('relaties/relatieCreated', response.data.relatie);
            vm.relaties.push(response.data.relatie);
          }
          vm.$router.push({name: 'Relatie',params :{id : response.data.relatie.Id}});
        })
        .catch(function(error) {
          console.log("Error on Authentication", error);
        });
    },
    onRowSelected(items) {
      console.dir(items);
      this.$router.push({name: 'Relatie',params :{id : items[0].Id}});
    }
  },
};
</script>